module.exports = __webpack_public_path__ + "img/securitas.e8e2414d.png";